export default __webpack_public_path__ + "static/media/stargaragen_1.101fc109.jpg";